//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - Start

import { deleteAlert, deleteMultipleAlerts, modifyScripAlert, setScripAlerts } from "../../apis/alert_nodeengine";
import { _getAlerts } from "../../controllers";
import { _getWhatsHotData } from "../../controllers/watchlist";
import { ALERTS } from "../actionTypes";
import { getWhatsHotDataSuccess } from "./dontMiss";
import { toastConfig } from "./toast";



export const getAlerts = (user_id) => async (dispatch, getState) => {
    // const whatsHotData = getState().dontMiss?.whatsHotData;
    // let arrWhatsHotData = [];
    // if (whatsHotData?.length > 0) {
    //     arrWhatsHotData = whatsHotData;
    // } else {
    //     const arrWhatsHotDataFromApi = await _getWhatsHotData();
    //     arrWhatsHotData = arrWhatsHotDataFromApi?.data.data.result;
    //     dispatch(getWhatsHotDataSuccess(arrWhatsHotDataFromApi?.data.data.result));
    // }

    const objResp = await _getAlerts(user_id);
    if (objResp?.status) {
        dispatch(getAlertsSuccess(objResp?.data?.arrActiveAlert));
        dispatch(getAlertsTriggedSuccess(objResp?.data?.arrAlertTrigged));
    } else {
        dispatch(getAlertsFailure([]));
        dispatch(getAlertsTRiggedFailure([]));
    }
    return Promise.resolve(objResp?.data?.arrActiveAlert);
};


export const setAlert = (payload) => async (dispatch) => {
    try {
        const objresp = await setScripAlerts(payload);

        dispatch(setAlertsSuccess(objresp?.data));
    } catch (error) {
        dispatch(toastConfig({ show: true, message: 'Unable to set alert.', button: [{ btnName: "ok", type: "CLOSE", className: "btn btn-outline-active ms-3" }] }));
        dispatch(setAlertsFailure({}));
        console.log(error);

    }
};

export const modifyAlert = (payload) => async (dispatch) => {
    try {
        const objresp = await modifyScripAlert(payload);
        dispatch(modifyAlertResponce(objresp?.data));
    } catch (error) {
        console.log(error);
        if (error?.response?.data) {
            dispatch(modifyAlertResponce(error?.response?.data));

        } else {
            dispatch(modifyAlertResponce({}));
        }
    }
};

export const removeAlert = (payload) => async (dispatch) => {
    try {
        const objresp = await deleteAlert(payload);

        dispatch(deleteAlertResponce(objresp?.data));
        return Promise.resolve(objresp);
    } catch (error) {
        console.log(error);
        return Promise.reject(error);
    }
};
//Azeem Khan : 23-04-2024 : BT-107432 -  Breeze - Alerts - Start
// for delete nesper alerts
export const removeMultipleAlerts = (payload) => async (dispatch) => {
    try {
        const objResp = await deleteMultipleAlerts(payload);

        dispatch(deleteAlertResponce(objResp?.data));
        return Promise.resolve(objResp);

    } catch (error) {
        return Promise.reject(error);

    }

};

export const setTriggerAlertCount = (payload) => {
    return { type: ALERTS.SET_TRIGGER_ALERT_COUNT, payload: payload };
};
//Azeem Khan : 23-04-2024 : BT-107432 -  Breeze - Alerts - End










export const getAlertsSuccess = (payload) => {
    return { type: ALERTS.GET_ALERTS_SUCCESS, payload: payload };
};

export const getAlertsFailure = (payload) => {
    return { type: ALERTS.GET_ALERTS_FAILURE, payload: payload };
};

export const getAlertsTriggedSuccess = (payload) => {
    return { type: ALERTS.GET_ALERT_TRIGGED_SUCCESS, payload: payload };
};

export const getAlertsTRiggedFailure = (payload) => {
    return { type: ALERTS.GET_ALERT_TRIGGED_FAILURE, payload: payload };
};

export const setAlertsSuccess = (payload) => {
    return { type: ALERTS.SET_ALERTS_SUCCESS, payload: payload };
};

export const setAlertsFailure = (payload) => {
    return { type: ALERTS.SET_ALERTS_FAILURE, payload: payload };
};
export const modifyAlertResponce = (payload) => {
    return { type: ALERTS.MODIFY_ALERT_RESPONCE, payload: payload };
};
export const deleteAlertResponce = (payload) => {
    return { type: ALERTS.DELETE_ALERT_RESPONCE, payload: payload };
};



export const searchAlertBySymbol = (payload) => {
    return { type: ALERTS.SEARCH_ALERT_BY_SYMBOL, payload: payload };
};
export const searchAlertByDropdown = (payload) => {
    return { type: ALERTS.SEARCH_ALERT_BY_DROPDOWN, payload: payload };
};
export const setActiveAlertTabByDefault = (payload) => {
    return { type: ALERTS.SET_ACTIVE_ALERT_TAB_BY_DEFAULT, payload: payload };
};

//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - End

